// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__LXUkA","header":"PatientBlock_header__1G3sR","label":"PatientBlock_label__230Be","option":"PatientBlock_option__2h8Vr"};